<template>
<div>
    <div class="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item> 
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  <div class="contenter">
    <div class="title">
      <span class="el-icon-document"></span>
      <span>基因家族聚类分析</span>
    </div>
    <div class="des">
      基因家族是进化上存在共同祖先的一类基因，基因家族的成员之间序列相似并通常具有相近生物学功能。通过基因家族聚类，得到单拷贝基因家族和多拷贝基因家族，共有的基因家族和特有的基因家族。其中共有的基因家族可能是维持生存的保守基因，而特有基因则可能和物种的生物学特性，生存环境相关。通过GO和KEGG功能富集分析，我们可以分析共有基因家族以及特有基因家族在哪些GO
      term和KEGG
      pathway富集，从基因层面上解释目标物种重要生物学特性的形成原理，以及在特殊生存环境中的适应性进化机制。
    </div>
    <div class="img">
      <img src="../../../assets/u50.png" /><br /><br />
      <span>共有和特有基因家族分析结果示例 （Ling et al., 2018）</span><br />
      <span
        >Ling H Q, Ma B, Shi X, et al. Genome sequence of the progenitor of
        wheat A subgenome Triticum urartu. Nature, 2018, 557(7705):
        424-428.</span
      >
    </div>
  </div></div>
</template>
<script>
export default {};
</script>
<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.contenter {
  width: 1140px;
  margin: 0 auto;
  /* height: 500px; */
  box-shadow: 0 0 10px #bbb;
  padding: 0 30px;
  background: #fff;
}
.contenter .title {
  height: 70px;
  width: 100%;
  /* border: 1px solid red; */
  line-height: 70px;
  font-size: 16px;
  font-weight: bold;
}
.contenter .title .el-icon-document {
  margin-right: 10px;
  font-size: 20px;
  /* line-height: 30px; */
  color: seagreen;
  font-weight: bold;
}
.contenter .des {
  background: #eef6f0;
  color: #555;
  line-height: 25px;
  padding: 15px 20px;
  font-size: 14px;
  text-indent: 30px;
}
.contenter .img {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  line-height: 25px;
  overflow: auto;
  padding-bottom: 30px;
}
</style>